import { TranslationTextVm } from "./buildTranslationTextVm";

interface CopyOriginProps {
    show: boolean;
    originText: string;
}

export const getCopyOriginProps = (vm: TranslationTextVm): CopyOriginProps => ({
    show: vm.isMissingTranslation,
    originText: vm.placeholderText ?? "",
});
